import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { AssetsForms } from '@/entities/assets';
import {
  ALLOWED_LABELS_ARR,
  HelperRenderType,
  ValueType,
} from '@/shared/lib/forms/form-wrapper.types';
import { AssetDto } from '@/shared/lib/sj-orm/models/asset.dto';

type FormFieldConfig = ValueType<HelperRenderType, unknown, unknown>;
export type FormConfig = Record<string, FormFieldConfig>;

type Props = {
  step: number;
  asset: AssetDto;
};

export const useFormFields = ({ step, asset }: Props) => {
  const { t } = useTranslation('assets');

  const { formData, formValues } = useMemo(() => {
    const generalForm = AssetsForms[asset.category]?.[step];

    if (!generalForm) {
      return { formData: {}, formValues: [] };
    }

    const filteredFormData: FormConfig = {};
    const filteredKeys: Array<keyof AssetDto> = [];

    for (const key of Object.keys(generalForm) as Array<keyof AssetDto>) {
      // TODO: refactor types
      // @ts-ignore
      const value = generalForm[key];
      if (value || ALLOWED_LABELS_ARR.includes(value.type)) {
        filteredFormData[key] = value;
        filteredKeys.push(key);
      }
    }

    return { formData: filteredFormData, formValues: filteredKeys };
  }, [asset, step]);

  const formatLabel = (
    label: string | { prefix: string; postfix: string; fieldKey: string } | undefined,
  ) => {
    if (!label) return '';
    if (typeof label === 'string') return t(label);

    return t(label.postfix);
  };

  return useMemo(
    () => ({
      formValues,
      formData,
      formatLabel,
    }),
    [formValues, formData, formatLabel],
  );
};
